module.exports = __webpack_public_path__ + "static/media/cleo-mobile-411x93@2x.94b52772.webp";